import { module } from 'modujs';
import { $html } from '../utils/dom';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
		window.addEventListener("resize",()=>{
			this.detectDevice();
		});

		this.detectDevice();
    }

	detectDevice() {
		let landscape = window.matchMedia("(orientation: landscape)");
		const value = String(this.deviceType() == 'mobile' && landscape.matches && window.innerWidth < 1000);
		if ($html.getAttribute('data-device-notice') !== value) {
			$html.setAttribute('data-device-notice', value);
		}
	}

    deviceType () {
        let ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "tablet";
        }
        else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return "mobile";
        }
        return "desktop";
    }
}
